import { selectStateData } from 'src/core/redux/selectors';
import { DesignType } from 'src/models';

export const selectSataticMenuItems = (state) => {
  const data = selectStateData(DesignType.NAME, 'list')(state)?.data;

  return data?.menuItems;
};
